import { render, staticRenderFns } from "./editEmployeePersonal.vue?vue&type=template&id=31b12e08&scoped=true"
import script from "./editEmployeePersonal.vue?vue&type=script&lang=js"
export * from "./editEmployeePersonal.vue?vue&type=script&lang=js"
import style0 from "./editEmployeePersonal.vue?vue&type=style&index=0&id=31b12e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b12e08",
  null
  
)

export default component.exports